module.exports = __webpack_public_path__ + "img/Z86Q_09.ff11f20c.jpg";